const getAndCacheUtmParams = () => {
    const CACHE_KEY = 'utm_cache';
    const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
    
    // Get current URL UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    const currentUtms = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_term: urlParams.get('utm_term'),
        utm_content: urlParams.get('utm_content')
    };
    
    // Remove null values
    const currentUtmsFiltered = Object.fromEntries(
        Object.entries(currentUtms).filter(([key, value]) => value !== null)
    );
    
    try {
        const cached = localStorage.getItem(CACHE_KEY);
        const now = Date.now();
        
        if (cached) {
            const { timestamp, utms } = JSON.parse(cached);
            
            // Check if cache is still valid (within 12 hours)
            const isExpired = now - timestamp > CACHE_DURATION;
            
            // Check if current UTMs are different from cached ones
            console.log("HEREHERE", currentUtmsFiltered, utms)
            const utmsChanged = JSON.stringify(currentUtmsFiltered) !== JSON.stringify(utms);
            
            if (!isExpired && !utmsChanged) {
                // Use cached UTMs
                return utms;
            }
        }
        
        // Cache new UTMs (either expired, changed, or no cache exists)
        if (Object.keys(currentUtmsFiltered).length > 0) {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                timestamp: now,
                utms: currentUtmsFiltered
            }));
            return currentUtmsFiltered;
        }
        
        // If no current UTMs, try to use cached ones if they're not expired
        if (cached) {
            const { timestamp, utms } = JSON.parse(cached);
            if (now - timestamp <= CACHE_DURATION) {
                return utms;
            }
        }
        
        // No UTMs available
        return {};
        
    } catch (error) {
        console.error('Error handling UTM cache:', error);
        return currentUtmsFiltered;
    }
};

const setVisibility = () => {
    const noAppEls = document.querySelectorAll('.no-app');
    const noWebEls = document.querySelectorAll('.no-web');
    const utmParams = document.querySelectorAll('[class*="assigned-utm_"]');
    
    if (noAppEls.length || noWebEls.length) {
        const params = new URLSearchParams(window.location.search);
        const hasKinn = params.get('app') === 'kinn';

        noAppEls.forEach(function(el) {
            if (!hasKinn) el.classList.remove('no-app');
        });
        noWebEls.forEach(function(el) {
            if (hasKinn) el.classList.remove('no-web');
        });
    }
    
    if (utmParams.length) {
        // Use cached UTM parameters
        const cachedUtms = getAndCacheUtmParams();
        const utmMedium = cachedUtms.utm_medium;
        
        console.log("cached UTMs", cachedUtms);
        console.log("utmMedium", utmMedium);
        
        utmParams.forEach(function(el) {
            const classList = el.className.split(' ');
            const utmClasses = classList.filter(cls => cls.startsWith('assigned-utm_'));
            
            if (utmClasses.length > 0) {
                const assignedMediums = utmClasses.map(cls => cls.replace('assigned-utm_', ''));
                
                if (utmMedium && assignedMediums.includes(utmMedium)) {
                    el.style.setProperty('display', 'block', 'important');
                } else {
                    el.style.display = 'none';
                }
            }
        });
    }
}

setVisibility();

(function() {
    document.addEventListener('DOMContentLoaded', function() {
        const galleries = document.querySelectorAll('.fs-multi-carousel');
        
        galleries.forEach(function(gallery) {
            const buttons = gallery.querySelectorAll('.fs-upsell-button[data-widget-id]');
            const contentItems = gallery.querySelectorAll('.fs-multi-content-item[data-widget-id]');
            
            buttons.forEach(function(button) {
                button.addEventListener('click', function() {
                    const targetWidgetId = this.getAttribute('data-widget-id');
                    
                    contentItems.forEach(function(item) {
                        item.classList.remove('active');
                    });
                    
                    buttons.forEach(function(btn) {
                        btn.classList.remove('active');
                    });
                    
                    const targetContent = gallery.querySelector('.fs-multi-content-item[data-widget-id="' + targetWidgetId + '"]');
                    if (targetContent) {
                        targetContent.classList.add('active');
                    }
                    
                    this.classList.add('active');
                });
            });
            
            const activeButton = gallery.querySelector('.fs-upsell-button.active');
            if (!activeButton && buttons.length > 0) {
                const activeContent = gallery.querySelector('.fs-multi-content-item.active');
                if (activeContent) {
                    const activeWidgetId = activeContent.getAttribute('data-widget-id');
                    const correspondingButton = gallery.querySelector('.fs-upsell-button[data-widget-id="' + activeWidgetId + '"]');
                    if (correspondingButton) {
                        correspondingButton.classList.add('active');
                    }
                } else {
                    buttons[0].classList.add('active');
                }
            }
        });
    });
})();